import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { encryptCredentials } from 'utils/storageUtils'

/**
 * AffiliateTokenHandler component for handling referral tokens from URL parameters.
 * This component captures referral tokens from URL query parameters and stores them
 * in a cookie. After storing, it removes the parameter from the URL to maintain
 * a clean user experience.
 *
 * The component itself doesn't render anything visible to the user.
 */
const AffiliateTokenHandler = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { affiliateCookieDurationHours } = useSelector((state) => state.uiConfig?.general) || {}

  useEffect(() => {
    if (searchParams?.get('token')) {
      const durationHours = Number(affiliateCookieDurationHours) || 24
      document.cookie = `refToken=${encryptCredentials(searchParams?.get('token'))}; expires=${new Date(new Date()?.getTime() + (durationHours * 60 * 60 * 1000))?.toUTCString()}`
      searchParams.delete('token')
      setSearchParams(searchParams)
    }
  }, [searchParams, setSearchParams, affiliateCookieDurationHours])

  // This component doesn't render anything visible
  return null
}

export default React.memo(AffiliateTokenHandler)
